// To use:  add the typeahead-stay-open attribute to a type ahead input, and add this.stayOpen to
// the typeahead-on-select call.  E.g.
// <input type="text"
// uib-typeahead="mood as mood.name for mood in vm.searchFilterOptions($viewValue, vm.moods, 'mood')
// typeahead-on-select="vm.toggleFilter('mood', $item); this.stayOpen()"
// typeahead-input-formatter="vm.filterQueries.queryStrings['mood']"
// typeahead-stay-open>
export function typeaheadStayOpen() {
    return {
        restrict: 'A',
        scope: true,
        priority: 100, //Set higher priority than ngModel so isolated scope works
        require: ['ngModel'],
        link: function (scope, element, attr, ctrls) {
            scope.stayOpen = function () {
                // Setting the view value will force the typeahead to stay open and update the results
                // after an option is selected.  Ideally we'd be calling $setViewValue instead of
                // triggering the parser manually but because we haven't changed the query it's not going to
                // fire unless we manually initate it.
                // Alternatively we can $setViewValue to null and back, but that produces a flicker.
                ctrls[0].$parsers[0](ctrls[0].$viewValue);
            };
        },
    };
}
